import { navigate } from '@teliaee/crm-components';
import { Button, Grid, GridColumn } from 'telia-front-react';
import { observer } from 'mobx-react';
import React, { useContext } from 'react';
import HasMandate from '../auth/HasMandate';
import { MandateType } from '../config/mandate';
import { RootStoreContext } from '../stores/RootStore';
import { createGaEvent } from '../util/GaUtil';
import PersonContactAddress from './PersonContactAddress';
import PersonContactInfo from './PersonContactInfo';
import PersonInfoDetails from './PersonInfoDetails';
const PersonInfo = observer(() => {
    const { translateStore: { translate } } = useContext(RootStoreContext);
    return (React.createElement(Grid, { borderWeight: "thin" },
        React.createElement(PersonInfoDetails, null),
        React.createElement(PersonContactInfo, null),
        React.createElement(PersonContactAddress, null),
        React.createElement(GridColumn, null,
            React.createElement(HasMandate, { mandates: [MandateType.LEGAL], matchAll: false },
                React.createElement(Button, { text: translate('personContactInfo.buttonChangeData'), onClick: () => {
                        navigate('/konto/andmete-uuendamine');
                        createGaEvent({
                            eventCategory: 'Iseteenindus - Konto',
                            eventAction: 'Isikuandmed',
                            eventLabel: 'personContactInfo.buttonChangeData'
                        });
                    } })))));
});
export default PersonInfo;
